export class ChartResult {
    public name: string;
    public quantity: number;

    constructor() {
        this.name = '';
        this.quantity = 0;
    }
}
